export const getTrustStatementsTranslated = (t) => [
  { id: "anonymous", label: t("landing.trust.anonymous"), icon: "shield" },
  { id: "hosting", label: t("landing.trust.hosting"), icon: "globe" },
  { id: "ownership", label: t("landing.trust.ownership"), icon: "lock" },
];
